"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MailRefusalFlagRadioButtonInput = void 0;
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var models_1 = require("../../../models");
var ChoiceLabel_1 = require("../ChoiceLabel");
var ErrorMessage_1 = require("../ErrorMessage");
var FieldHeading_1 = require("../FieldHeading");
var PropertyInputWrapper_1 = require("../PropertyInputWrapper");
var RadioButton_1 = require("../RadioButton");
var shared_1 = require("./shared");
var MailRefusalFlagRadioButtonInput = function (_a) {
    var propertyId = _a.propertyId, errorMessages = _a.errorMessages, _b = _a.disabled, disabled = _b === void 0 ? false : _b, className = _a.className, _c = _a.displayError, displayError = _c === void 0 ? false : _c, refusal = _a.refusal, design = _a.design, refusalLabel = _a.refusalLabel, receptionLabel = _a.receptionLabel, onChange = _a.onChange;
    var inputFont = design.colors.inputFont;
    var changeRefusal = function () {
        onChange(true);
    };
    var changeReception = function () {
        onChange(false);
    };
    return ((0, jsx_runtime_1.jsx)(PropertyInputWrapper_1.PropertyInputWrapper, __assign({ propertyId: propertyId, propertyType: models_1.PROPERTY_TYPE.mailRefusalFlag, inputFormatType: models_1.MAIL_REFUSAL_FLAG_PROPERTY_INPUT_TYPE.radio, errorMessages: errorMessages, className: className, displayError: displayError }, { children: (0, jsx_runtime_1.jsxs)("div", __assign({ role: "radiogroup", "aria-labelledby": (0, FieldHeading_1.getLabelId)(propertyId), "aria-errormessage": (0, ErrorMessage_1.getFieldErrorMessageId)(propertyId), "aria-invalid": displayError, "aria-disabled": disabled }, { children: [(0, jsx_runtime_1.jsx)(RadioButton_1.RadioButton, __assign({ value: shared_1.MAIL_REFUSAL_FLAG_VALUE_TYPE.refusal, name: propertyId, disabled: disabled, error: displayError, checked: refusal, onChange: changeRefusal }, { children: (0, jsx_runtime_1.jsx)(ChoiceLabel_1.ChoiceLabel, { color: inputFont, label: refusalLabel }) })), (0, jsx_runtime_1.jsx)(RadioButton_1.RadioButton, __assign({ value: shared_1.MAIL_REFUSAL_FLAG_VALUE_TYPE.reception, name: propertyId, disabled: disabled, error: displayError, checked: !refusal, onChange: changeReception, css: {
                        marginTop: '4px',
                    } }, { children: (0, jsx_runtime_1.jsx)(ChoiceLabel_1.ChoiceLabel, { color: inputFont, label: receptionLabel }) }))] })) })));
};
exports.MailRefusalFlagRadioButtonInput = MailRefusalFlagRadioButtonInput;
